import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const PaymentFailed = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const cardId = localStorage.getItem('cardId');

    if (cardId) {
      navigate(`/dashboard/${cardId}`);
    } else {
      navigate('/dashboard'); // Redirect to login if cardId is not found
    }
  }, [navigate]);

  return null; // No UI is needed for redirection
};

export default PaymentFailed;
